export default "__VITE_ASSET__MAXzEJ5z__"